enum UserEventCategory {
  Registration = 'Registration',
  Kyc = 'Kyc',
  Investment = 'Investment',
  Other = 'Other',
}

export default UserEventCategory;
